module.exports = __webpack_public_path__ + "static/media/ToolingRecords.1486614e31af692c4e40d2fc65bc2e7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ToolingRecords.png
// module id = 4327
// module chunks = 1